/**
 * Nilai uang/persen pada tab Monitoring Program datang dari backend sebagai string yang
 * sudah terformat ("Rp 18.544.000,00", "1% dari omzet", "Rp 0,00"), jadi nol hanya bisa
 * dinilai dari isi karakternya — tidak ada angka mentah untuk dibandingkan.
 *
 * [MAI-1296] Kolom Estimasi Budget Hadiah dan [MAI-2601] kartu ringkasan modal memakai
 * aturan yang sama: nol berarti distributor belum mendapat hadiah, tampilkan "-".
 */
export function hasNonZeroAmount(value: string | null | undefined): boolean {
  return !!value && /[1-9]/.test(value);
}
